import React from 'react'
import Cards from './Cards'
function Service() {
    return (
        <div id="Service" >
            <Cards />
        </div>
    )
}

export default Service

